import React from "react";
import pic from "../Images/pic.jpg";
import "./Profile.css";

const Profile = () => {
  return (
    <div className=" ">
      <div className="Profile d-flex align-items-center ps-3">
        <img src={pic} alt="" />
        <div className="ms-2">
          <h5 className="m-0 p-0 fw-bold">Md Zahed Iqbal</h5>
          <p className="m-0 p-0 designation text-secondary">
            MERN Stack Developer
          </p>
        </div>
      </div>
      <div className="row profile-details p-3">
        <div className="col-md-4 text-center">
          <h4 className="fw-bold m-0 p-0">
            62<small className="text-secondary weight">kg</small>
          </h4>
          <p className="text-secondary m-0 p-0">weight</p>
        </div>
        <div className="col-md-4 text-center">
          <h4 className="fw-bold m-0 p-0">
            5.7<small className="text-secondary weight">In</small>
          </h4>
          <p className="text-secondary m-0 p-0">Height</p>
        </div>
        <div className="col-md-4 text-center">
          <h4 className="fw-bold m-0 p-0">
            38<small className="text-secondary weight">Yrs</small>
          </h4>
          <p className="text-secondary m-0 p-0">Age</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
